import { getUserIPData } from "../services/country";
import { barProgress } from "../utils/bar-progress";
import { $Q, $Qll } from "../utils/query-selector";
import { getCountryTax } from "./custom-taxes";

/**
 * show in the front page the new calculated price
 * @param {Node} element -> HTML node price
 * @param {Number} price -> Calculated number
 */
const printPriceVat = (element, price) => {
  const formattedPrice = price.toFixed(2).replace(".", ",").concat("€");
  // eslint-disable-next-line no-param-reassign
  element.innerText = formattedPrice;
}

const printCartTotalPrice = (price, estimate) => {
  const cartButton = $Qll("#btn_cart_total_price");
  const estimateVat = $Qll("#cart_estimate_vat");
  if (cartButton.length === 0 || estimateVat.length === 0) return;

  const formattedPrice = (price / 100).toFixed(2).replace(".", ",");
  const formattedEstimate = (estimate / 100).toFixed(2).replace(".", ",");
  

  cartButton.forEach((element, i) => {
    // eslint-disable-next-line no-param-reassign
    const currency = element.dataset.currencySymbol || "€";
    element.textContent = ` ${formattedPrice} ${currency}`;
    if (estimateVat[i]) {
      const currencySymbol = estimateVat[i].dataset.currencySymbol || "€";
      estimateVat[i].textContent = ` ${formattedEstimate} ${currencySymbol}`;
    }
  });

  barProgress($Q('#progress-bar-data'), price);
}

/**
 * If isEnabledTax is false, hidde this elements
 */
const hiddePriceVat = () => {
  const ttcPrices = $Qll(".ttc_function");

  ttcPrices.forEach((ttcPrice) => {
    ttcPrice.classList.add("hidden");
  });
}

const preparePriceVat = (vat, value, container) => {
  const ttcPrices = $Qll(".ttc", container);
  ttcPrices.forEach((ttcPrice) => {
    const price = parseFloat(ttcPrice.dataset.price.replace(",", "."));
    let priceWithVat;

    if (value != null) {
      priceWithVat = (price + ((vat / 100) * price)) * value;
    } else {
      priceWithVat = (price + ((vat / 100) * price));
    }

    printPriceVat(ttcPrice, priceWithVat);
  });
}

/**
 * Calculate the new price with custom tax
 * @param {Number} vat -> cutom tax for user country
 */
const calculatePriceVat = (vat, value, vatContainer) => {
  if (vatContainer) {
    preparePriceVat(vat, value, vatContainer);
  }
  else {
    const priceContainer = $Qll(".price-product-js")
    priceContainer.forEach((container) => {
      preparePriceVat(vat, value, container);
    });
  }
}

const calculateTotalPriceVat = (vat) => {
  const cartTotalPrice = $Q(".cartpage-footer__price");
  const tvaNodes = $Qll(".cartpage-footer__tva");
  if (cartTotalPrice != null && !window.cfCurrencySwitcher) {
    const priceBar = parseFloat(cartTotalPrice.dataset.priceBar);
    const totalPriceWithVat = priceBar + ((vat / 100) * priceBar);
    const vatEstimate = totalPriceWithVat - priceBar;
    if (tvaNodes.length > 0) {
      printCartTotalPrice(totalPriceWithVat, vatEstimate);
    } else {
      printCartTotalPrice(priceBar, 0);
    }
  }
}

/**
 * If the user is logged calculate the custom price
 * with the user direction
 * if the user is not logged calculate the custom price
 * with IP data
 */
export const priceVat = async (value, vatContainer) => {
  if (window.cfCurrencySwitcher) return;
  const isEnabledTax = $Q("#custom_tax_function");

  if (isEnabledTax != null) {
    const isEnabled = isEnabledTax.value

    if (isEnabled === "true") {
      const { detected_values: { country: { handle } } } = await getUserIPData();
      const userZone = $Q("#user_zone").value;
      let customTax;

      if (userZone === "user_not_logged") {
        customTax = getCountryTax(handle);
      } else {
        customTax = getCountryTax(userZone);
      }

      calculatePriceVat(customTax, value, vatContainer);
      calculateTotalPriceVat(customTax);
    } else {
      hiddePriceVat();
    }
  }

}
